import type { NodeTypes } from '@xyflow/react'
import { AddNoteNode } from './nodes/AddNoteNode'
import { AddToPipelineNode } from './nodes/AddToPipelineNode'
import { AiAgentSmsNode } from './nodes/AiAgentSmsNode'
import { AssignOwnerNode } from './nodes/AssignOwnerNode'
import { BranchNode } from './nodes/BranchNode'
import { CreateTaskNode } from './nodes/CreateTaskNode'
import { EditObjectNode } from './nodes/EditObjectNode'
import { EditTaskNode } from './nodes/EditTaskNode'
import { ExitNode } from './nodes/ExitNode'
import { FilterNode } from './nodes/FilterNode'
import { InitiateCallNode } from './nodes/InitiateCallNode'
import { LogFollowUpNode } from './nodes/LogFollowUpNode'
import { SendNotificationNode } from './nodes/SendNotificationNode'
import { SendPaperworkNode } from './nodes/SendPaperworkNode'
import { SendSmsNode } from './nodes/SendSmsNode'
import { TagObjectNode } from './nodes/TagObjectNode'
import { TriggerNode } from './nodes/TriggerNode'
import { UpdateAppointmentNode } from './nodes/UpdateAppointmentNode'
import { WaitForCallResultNode } from './nodes/WaitForCallResultNode'
import { WaitForKeywordNode } from './nodes/WaitForKeywordNode'
import { WaitForReplyNode } from './nodes/WaitForReplyNode'
import { WaitNode } from './nodes/WaitNode'
import { WaitUntilNode } from './nodes/WaitUntilNode'

/** Maps each WorkflowNodeKind to its renderer. Defined once at module scope so the
 *  reference is stable across renders (React Flow re-mounts nodes otherwise). */
export const nodeTypes: NodeTypes = {
  trigger: TriggerNode,
  sendSms: SendSmsNode,
  aiAgentSms: AiAgentSmsNode,
  initiateCall: InitiateCallNode,
  createTask: CreateTaskNode,
  editTask: EditTaskNode,
  tagObject: TagObjectNode,
  addToPipeline: AddToPipelineNode,
  editObject: EditObjectNode,
  updateAppointment: UpdateAppointmentNode,
  assignOwner: AssignOwnerNode,
  addNote: AddNoteNode,
  logFollowUp: LogFollowUpNode,
  sendPaperwork: SendPaperworkNode,
  sendNotification: SendNotificationNode,
  wait: WaitNode,
  waitUntil: WaitUntilNode,
  filter: FilterNode,
  waitForReply: WaitForReplyNode,
  waitForKeyword: WaitForKeywordNode,
  waitForCallResult: WaitForCallResultNode,
  branch: BranchNode,
  exit: ExitNode,
}
